var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightEffect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 423,
    height: 566,
    viewBox: "0 0 423 566",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_305_22326)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_305_22326)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_305_22326)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_305_22326",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 624,
    height: 566
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M623.213 0H0.117188V565.8H623.213V0Z",
    fill: "url(#paint0_radial_305_22326)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_305_22326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.76501 406.049H-57.7891V467.603H3.76501V406.049Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3217 406.049H3.76758V467.603H65.3217V406.049Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.878 406.049H65.3242V467.603H126.878V406.049Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.431 406.049H126.877V467.603H188.431V406.049Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.988 406.049H188.434V467.603H249.988V406.049Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.546 406.049H249.992V467.603H311.546V406.049Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.103 406.049H311.549V467.603H373.103V406.049Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.658 406.049H373.104V467.603H434.658V406.049Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.76501 467.586H-57.7891V529.14H3.76501V467.586Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.76501 -24.7188H-57.7891V36.8353H3.76501V-24.7188Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3217 467.586H3.76758V529.14H65.3217V467.586Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3217 -24.7188H3.76758V36.8353H65.3217V-24.7188Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.878 467.586H65.3242V529.14H126.878V467.586Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.878 -24.7188H65.3242V36.8353H126.878V-24.7188Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.431 467.586H126.877V529.14H188.431V467.586Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.431 -24.7188H126.877V36.8353H188.431V-24.7188Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.988 467.586H188.434V529.14H249.988V467.586Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.988 -24.7188H188.434V36.8353H249.988V-24.7188Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.546 467.586H249.992V529.14H311.546V467.586Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.546 -24.7188H249.992V36.8353H311.546V-24.7188Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.103 467.586H311.549V529.14H373.103V467.586Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.103 -24.7188H311.549V36.8353H373.103V-24.7188Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.658 467.586H373.104V529.14H434.658V467.586Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.658 -24.7188H373.104V36.8353H434.658V-24.7188Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.76501 529.125H-57.7891V590.679H3.76501V529.125Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.76501 36.8203H-57.7891V98.3744H3.76501V36.8203Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3217 529.125H3.76758V590.679H65.3217V529.125Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3217 36.8203H3.76758V98.3744H65.3217V36.8203Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.878 529.125H65.3242V590.679H126.878V529.125Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.878 36.8203H65.3242V98.3744H126.878V36.8203Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.431 529.125H126.877V590.679H188.431V529.125Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.431 36.8203H126.877V98.3744H188.431V36.8203Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.988 529.125H188.434V590.679H249.988V529.125Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.988 36.8203H188.434V98.3744H249.988V36.8203Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.546 529.125H249.992V590.679H311.546V529.125Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.546 36.8203H249.992V98.3744H311.546V36.8203Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.103 529.125H311.549V590.679H373.103V529.125Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.103 36.8203H311.549V98.3744H373.103V36.8203Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.658 529.125H373.104V590.679H434.658V529.125Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.658 36.8203H373.104V98.3744H434.658V36.8203Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.76501 98.3574H-57.7891V159.911H3.76501V98.3574Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3217 98.3574H3.76758V159.911H65.3217V98.3574Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.878 98.3574H65.3242V159.911H126.878V98.3574Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.431 98.3574H126.877V159.911H188.431V98.3574Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.988 98.3574H188.434V159.911H249.988V98.3574Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.546 98.3574H249.992V159.911H311.546V98.3574Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.103 98.3574H311.549V159.911H373.103V98.3574Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.658 98.3584H373.104V159.912H434.658V98.3584Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.76501 159.896H-57.7891V221.45H3.76501V159.896Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3217 159.896H3.76758V221.451H65.3217V159.896Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.878 159.896H65.3242V221.451H126.878V159.896Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.431 159.896H126.877V221.451H188.431V159.896Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.988 159.896H188.434V221.45H249.988V159.896Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.546 159.896H249.992V221.451H311.546V159.896Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.103 159.896H311.549V221.45H373.103V159.896Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.658 159.896H373.104V221.45H434.658V159.896Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.76501 221.434H-57.7891V282.988H3.76501V221.434Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3217 221.434H3.76758V282.988H65.3217V221.434Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.878 221.434H65.3242V282.988H126.878V221.434Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.431 221.434H126.877V282.988H188.431V221.434Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.988 221.434H188.434V282.988H249.988V221.434Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.546 221.434H249.992V282.988H311.546V221.434Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.103 221.434H311.549V282.988H373.103V221.434Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.658 221.434H373.104V282.988H434.658V221.434Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.76501 282.973H-57.7891V344.527H3.76501V282.973Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3217 282.973H3.76758V344.527H65.3217V282.973Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.878 282.973H65.3242V344.527H126.878V282.973Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.431 282.973H126.877V344.527H188.431V282.973Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.988 282.973H188.434V344.527H249.988V282.973Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.546 282.973H249.992V344.527H311.546V282.973Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.103 282.973H311.549V344.527H373.103V282.973Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.658 282.974H373.104V344.528H434.658V282.974Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.76501 344.511H-57.7891V406.065H3.76501V344.511Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3217 344.511H3.76758V406.065H65.3217V344.511Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.878 344.511H65.3242V406.065H126.878V344.511Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.431 344.511H126.877V406.065H188.431V344.511Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.988 344.511H188.434V406.065H249.988V344.511Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.546 344.511H249.992V406.065H311.546V344.511Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.103 344.511H311.549V406.065H373.103V344.511Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.658 344.511H373.104V406.065H434.658V344.511Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.969 267.235V283.133H111.07",
    stroke: "url(#paint1_linear_305_22326)",
    strokeWidth: 1.50479,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.631 267.235V282.796H142.868",
    stroke: "url(#paint2_linear_305_22326)",
    strokeWidth: 1.50479,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.631 298.356V282.795H142.868",
    stroke: "url(#paint3_linear_305_22326)",
    strokeWidth: 1.50479,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.632 298.356V282.795H110.395",
    stroke: "url(#paint4_linear_305_22326)",
    strokeWidth: 1.50479,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.534 144.104V160.003H172.635",
    stroke: "url(#paint5_linear_305_22326)",
    strokeWidth: 1.50479,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.195 144.104V159.664H204.432",
    stroke: "url(#paint6_linear_305_22326)",
    strokeWidth: 1.50479,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.195 175.225V159.664H204.432",
    stroke: "url(#paint7_linear_305_22326)",
    strokeWidth: 1.50479,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.196 175.225V159.664H171.959",
    stroke: "url(#paint8_linear_305_22326)",
    strokeWidth: 1.50479,
    strokeLinecap: "round"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_305_22326",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(311.665 282.9) rotate(90) scale(752.239 828.415)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_305_22326",
    x1: 127.176,
    y1: 267.235,
    x2: 110.865,
    y2: 282.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0394381,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_305_22326",
    x1: 126.42,
    y1: 267.235,
    x2: 142.395,
    y2: 283.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0394381,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_305_22326",
    x1: 126.42,
    y1: 298.356,
    x2: 142.395,
    y2: 282.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0394381,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_305_22326",
    x1: 126.842,
    y1: 298.356,
    x2: 110.867,
    y2: 282.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0394381,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_305_22326",
    x1: 188.74,
    y1: 144.104,
    x2: 172.43,
    y2: 159.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0394381,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_305_22326",
    x1: 187.985,
    y1: 144.104,
    x2: 203.959,
    y2: 160.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0394381,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_305_22326",
    x1: 187.985,
    y1: 175.225,
    x2: 203.959,
    y2: 159.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0394381,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_305_22326",
    x1: 188.408,
    y1: 175.225,
    x2: 172.431,
    y2: 159.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0394381,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_305_22326"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 624.48,
    height: 565.8,
    fill: "white",
    transform: "translate(0.119141)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_305_22326"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 624.48,
    height: 565.8,
    fill: "white",
    transform: "translate(0.119141)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_305_22326"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 624.487,
    height: 565.8,
    fill: "white",
    transform: "translate(0.117188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightEffect);
export default __webpack_public_path__ + "static/media/right-effect.9dbc35a327275c31f9285b9349c98794.svg";
export { ForwardRef as ReactComponent };